import { render, staticRenderFns } from "./WorkflowPrepProcessAuditTrail.vue?vue&type=template&id=de167af8"
import script from "./WorkflowPrepProcessAuditTrail.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepProcessAuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports